import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
const api=axios.create({baseURL:'https://api.xxmac.win',timeout:30000})
api.interceptors.request.use(async config=>{const account=firebase.auth().currentUser;config.headers=config.headers||{};if(account)config.headers.Authorization='Bearer '+await account.getIdToken();if(config.method==='post'&&!config.headers['x-idempotency-key'])config.headers['x-idempotency-key']='request-'+Date.now()+'-'+Math.random().toString(36).slice(2);return config})
export default api
